import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import FetchModule from '../../Model/Network/FetchModule';

import ProfilePath from '../../Image/DefaultProfile.png';
import SearchIcon from '../../Image/SearchIcon.png';

export default function AdminLoginChangeModal(props) {
  const { close } = props;

  const navigate = useNavigate();

  const [stores, setStores] = useState([]);
  const [useStores, setUseStores] = useState([]);
  const [value, setValue] = useState('');

  const TopLevelRef = useRef();

  // 모달 오픈 시 body 스크롤 잠금 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;

    return () => document.body.style = `overflow: auto`;
  }, [])

  // 전환 가능한 업체 목록 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('account/change/list', 'GET');

        if (responseData.status === 200) {
          // 대표 대회가 없는 계정(organizerId 0, 예: test1)은 전환해도 새 이벤트 모드로 빠지므로 제외 //
          const filteredStores = responseData.data.filter((store) => store.organizerId !== 0);

          setStores(filteredStores);
        }
        else if (responseData.status === 401) navigate('/login');
        else alert('서버와 연결이 불안정합니다. 잠시후 다시시도해 주세요.');
      }
    )();
  }, [navigate])

  // 검색어에 따른 목록 필터링 (한글 초성 검색 지원) //
  useEffect(() => {
    if (value === '') {
      setUseStores(stores);
      return;
    }

    const nameList = [];
    const loginIdList = [];
    const titleList = [];

    const lowerValue = value.toLowerCase();

    for (let i = 0; i < stores.length; i++) {
      const store = stores[i];

      if ((store.name || '').toLowerCase().includes(lowerValue)) nameList.push(store);
      else if ((store.loginId || '').toLowerCase().includes(lowerValue)) loginIdList.push(store);
      else if ((store.title || '').toLowerCase().includes(lowerValue)) titleList.push(store);
    }

    if (nameList.length === 0 && loginIdList.length === 0 && titleList.length === 0) {
      for (let i = 0; i < stores.length; i++) {
        const store = stores[i];

        if (match(lowerValue, (store.name || '').toLowerCase())) nameList.push(store);
        else if (match(lowerValue, (store.title || '').toLowerCase())) titleList.push(store);
      }
    }

    const totalList = nameList.concat(loginIdList).concat(titleList);

    setUseStores(totalList);
  }, [stores, value])

  // 입력된 글자가 한글인지 확인 //
  function is_kr(value) {
    if (value === undefined) return false;

    return ((('ㄱ'.charCodeAt() <= value.charCodeAt()) && (value.charCodeAt() <= 'ㅎ'.charCodeAt()))
            || (('가'.charCodeAt() <= value.charCodeAt()) && value.charCodeAt() <= '힣'.charCodeAt()));
  }

  // 한글 글자 유니코드 추출하여 검색 조건 확인 //
  function kr_num(value) {
    return value.charCodeAt() - '가'.charCodeAt();
  }

  // 초성 중성 종성 구분하여 연산 //
  function kr_list(value) {
    const consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
                          , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    const res = [value];

    const kr_num_s = kr_num(value);

    if (kr_num_s > 0) {
      // 초성 + 중성일 경우 //
      if (kr_num_s % 28 !== 0) {
        res.push(String.fromCharCode(((parseInt(kr_num_s / 28) * 28) + '가'.charCodeAt())));
      }

      res.push(consonant_list[parseInt(kr_num_s / 588)])
    }

    return res;
  }

  // 한글, 영어 구분하여 검색 처리 //
  function eq_kr(value, data) {
    if (is_kr(value) && is_kr(data)) return kr_list(data).includes(value);
    else return value === data;
  }

  // 받침 확인하기 //
  function eq_kr_pos(value, data, nextData) {
    const consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
                          , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    const kr_pos = [
      [0, 0], [1, 0], [2, 1], [2, 9], [4, 2], [1, 12], [2, 18],
      [7, 3], [8, 5], [1, 0], [2, 6], [3, 7], [4, 9], [5, 16],
      [6, 17], [7, 18], [16, 6], [17, 7], [1, 9], [19, 9], [20, 10],
      [21, 11], [22, 12], [23, 14], [24, 15], [25, 16], [26, 17], [27, 18]
    ]

    if (!(is_kr(value) && is_kr(data) && is_kr(nextData))) return false;
    if (kr_num(value) < 0) return false;

    const s_pos = String.fromCharCode(value.charCodeAt() - kr_pos[kr_num(value) % 28][0])
    const s_pos_consonant = consonant_list[kr_pos[kr_num(value) % 28][1]]

    return (s_pos === data) && (kr_list(nextData).includes(s_pos_consonant));
  }

  // 일치하는 글자가 존재하는지 확인 //
  function match(value, data) {
    if (value === undefined || data === undefined) return false;

    const valueSize = value.length;
    const dataSize = data.length;

    if (dataSize < valueSize) return false;

    for (let i = 0; i < (dataSize - valueSize + 1); i++) {
      let res = true;

      for (let j = 0; j < valueSize; j++) {
        if (j === (valueSize - 1)) {
          if (!eq_kr(value[j], data[i + j])) {
            if (i + j + 1 < dataSize) {
              if (eq_kr_pos(value[j], data[i + j], data[i + j + 1])) break;
            }

            res = false;
            break;
          }
        }
        else {
          if (value[j] !== data[i + j]) {
            res = false;
            break;
          }
        }
      }

      if (res) return true;
    }

    return false;
  }

  // 검색 인풋 변경 //
  function onChangeSearchInput(e) {
    setValue(e.target.value);
  }

  // 전환할 업체 클릭시 로그인 세션 교체 //
  function onClickStoreInfo(data) {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('account/change/auth/' + data.organizerId, 'GET');

        if (responseData.status === 200) {
          window.localStorage.setItem('Token', 'Bearer ' + responseData.data.accessToken);
          window.localStorage.setItem('RefreshToken', 'Bearer ' + responseData.data.refreshToken);
          window.localStorage.setItem('PrimaryOrganizerId', responseData.data.organizerId);

          window.location.href = '/main/' + responseData.data.organizerId;
        }
        else if (responseData.status === 401) navigate('/login');
        else alert('서버와 연결이 불안정합니다. 잠시후 다시시도해 주세요.');
      }
    )();
  }

  // 업체 목록 렌더링 //
  function renderStoreList() {
    return useStores.map((data, index) => (
      <StoreInfoBox
        key={'AdminChangeStore-' + index}
        onClick={() => onClickStoreInfo(data)}>
        <StoreInfoWrapper>
          <LogoWrapper>
            <Logo src={!data.logo ? ProfilePath : data.logo} />
          </LogoWrapper>
          <ColumnTextWrapper>
            <NameText>{data.name}</NameText>
            <RowTextWrapper>
              <SubText>{data.loginId}</SubText>
              {
                (data.title !== undefined && data.title !== null && data.title !== '') &&
                <SubText>{data.title}</SubText>
              }
            </RowTextWrapper>
          </ColumnTextWrapper>
        </StoreInfoWrapper>
      </StoreInfoBox>
    ));
  }

  return (
    <Background>
      <TopLevelWrapper ref={TopLevelRef}>
        <ExplanationWrapper>
          <KorExplanation>관리자 로그인 전환</KorExplanation>
          <CountText>전환 가능한 업체 {stores.length}개</CountText>
        </ExplanationWrapper>
        <SearchInputWrapper>
          <SearchInput
            img={SearchIcon}
            placeholder='업체 이름이나 아이디, 대회명 검색'
            value={value}
            onChange={onChangeSearchInput} />
        </SearchInputWrapper>
        <ScrollView>
          {renderStoreList()}
        </ScrollView>
        <ButtonWrapper>
          <CloseButton onClick={close}>
            <ButtonText>닫기</ButtonText>
          </CloseButton>
        </ButtonWrapper>
      </TopLevelWrapper>
    </Background>
  )
}

const Background = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  left: 0;

  z-index: 500;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
`;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 500px;
  max-width: 92vw;
  height: 700px;
  max-height: 90vh;

  padding: 40px 0px;
  box-sizing: border-box;

  border-radius: 50px;
  background-color: #FFFFFF;

  transition: all 0.5s ease-in-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  flex-shrink: 0;

  gap: 8px;

  width: 90%;
`;

const KorExplanation = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 25px;

  margin: 0 0 0 0;

  color: #000000;
`;

const CountText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: #777777;
`;

const SearchInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  flex-shrink: 0;

  margin-top: 16px;

  width: 90.33%;
`;

const SearchInput = styled.input`
  font-family: NotoSansKR-Regular;
  font-size: 12px;
  line-height: 20px;

  padding: 0 0 0 40px;
  width: calc(100% - 42px);
  height: 38px;

  outline: none;
  border: 1px solid #DFDFDF;
  border-radius: 15px;
  color: #000000;

  background: url(${props => props.img}) no-repeat 12px center;
  background-size: 18px 18px;

  ::placeholder {
    color: #CBCBCB;
  }

  transition: all 0.3s ease-in-out;
`;

const ScrollView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  flex: 1 1 auto;
  min-height: 0;

  margin-top: 24px;

  width: 90.33%;

  gap: 12px;

  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    background-color: #DADADA;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: #F0F0F0;
    border-radius: 200px;
  }
`;

const StoreInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 97%;
  min-height: 80px;
  max-height: 80px;

  border-radius: 16px;
  border: 1px solid #DFDFDF;
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid #6DD49E;
  }
`;

const StoreInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 95%;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 70px;
  height: 70px;

  border-radius: 12px;

  overflow: hidden;
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;

  object-fit: cover;
`;

const ColumnTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 8px;

  margin-left: 12px;
`;

const RowTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const NameText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  margin: 0 0 0 0;

  color: #333333;
`;

const SubText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: #3F3F3F;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  flex-shrink: 0;

  gap: 14px;

  margin-top: 32px;
`;

const CloseButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 324px;
  height: 45px;

  border-radius: 23px;
  background: linear-gradient(90deg, #5BD98A 0%, #6DD49E 100%);

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 18px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;
